import React from 'react';
import { Loader2 } from 'lucide-react';

export interface LoaderProps extends React.ComponentPropsWithoutRef<'svg'> {
  size?: number | string;
  className?: string;
}

export const Loader = React.forwardRef<SVGSVGElement, LoaderProps>(function Loader(
  { size = 16, className = '', ...props },
  ref
) {
  return (
    <Loader2
      ref={ref}
      size={size}
      className={`animate-spin text-current ${className}`}
      {...props}
    />
  );
});

export default Loader; 
